/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { Injectable, Renderer2 } from "@angular/core";

export class NoOpRenderer {
  selectRootElement(selectorOrNode: string | any, debugInfo?: any): any {}
  createElement(parentElement: any, name: string, debugInfo?: any): any {}
  createViewRoot(hostElement: any): any {}
  createTemplateAnchor(parentElement: any, debugInfo?: any): any {}
  createText(parentElement: any, value: string, debugInfo?: any): any {}
  projectNodes(parentElement: any, nodes: any[]): void {}
  attachViewAfter(node: any, viewRootNodes: any[]): void {}
  detachView(viewRootNodes: any[]): void {}
  destroyView(hostElement: any, viewAllNodes: any[]): void {}

  listen(renderElement: any, name: string, callback: Function): Function {
    return function () {
      // no-op;
    };
  }

  listenGlobal(target: string, name: string, callback: Function): Function {
    return function () {
      // no-op;
    };
  }

  setElementProperty(renderElement: any, propertyName: string, propertyValue: any): void {}
  setElementAttribute(renderElement: any, attributeName: string, attributeValue: string): void {}
  /**
   * Used only in debug mode to serialize property changes to dom nodes as attributes.
   */
  setBindingDebugInfo(renderElement: any, propertyName: string, propertyValue: string): void {}
  setElementClass(renderElement: any, className: string, isAdd: boolean): void {}
  setElementStyle(renderElement: any, styleName: string, styleValue: string): void {}
  invokeElementMethod(renderElement: any, methodName: string, args?: any[]): void {}
  setText(renderNode: any, text: string): void {}
  animate(
    element: any,
    startingStyles: any,
    keyframes: any[],
    duration: number,
    delay: number,
    easing: string,
    previousPlayers?: any[],
  ): any {
    return null;
  }
}

@Injectable()
export class NoOpRootRenderer {
  public renderer = new NoOpRenderer();

  renderComponent(componentProto: any): NoOpRenderer {
    return this.renderer;
  }

  start(): void {}
}
